import React, { useEffect, useState } from "react";
import aboutBackground from "../../../../assets/img/aboutus/aboutBackground.svg";
import layout from "../../../../assets/img/careers/banner.svg";
import "./JoinOurTeam.css";
const JoinOurTeam = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);
  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 480px)"),
      isMobile: window.matchMedia("(min-width: 481px) and (max-width: 767px)"),
      isTablet: window.matchMedia("(min-width: 768px) and (max-width: 1024px)"),
      isTabletLandscape: window.matchMedia(
        "(min-width: 1025px) and (max-width: 1279px)"
      ),
      isDesktop: window.matchMedia("(min-width: 1280px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div className="career-bg">
        {/* Modal Component */}

        <div
          style={{
            textAlign: responsiveStatus ? "left" : "center",
            padding: "15px 10px",
          }}
        >
          {/* Decorative shapes */}
          <h3
            className="career-partner"
            style={{
              fontWeight: 600,
              fontSize: responsiveStatus ? "14px" : "20px",
            }}
          >
            Join Our Team
          </h3>
          <div className="become-agent-underline" />
          <h1
            className="career-title"
            style={{ fontSize: responsiveStatus ? "24px" : "20px" }}
          >
            Build Your Future with Us
          </h1>
          <p className="career-desc">
            At UAIC, we believe in empowering individuals to achieve their full
            potential. When you join our team, you’re not just starting a
            job—you’re embarking on a journey of growth, innovation, and
            success.{" "}
          </p>
        </div>
        <img
          src={layout}
          alt="Join Our Team Banner"
          className="full-width-img"
        />
      </div>
    </>
  );
};
const styles = {
  container: {
    // display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    // minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
    maxWidth: "1350px",
    margin: "0 auto",
    // backgroundImage: `url(${aboutBackground})`,
    // backgroundSize: "cover",
    // backgroundPosition: "center",
  },
  becomeAgentBG: {
    minHeight: "auto",
    textAlign: "center",
    // padding: '0 0 0px 0',
    // maxWidth: '700px',
    width: "100%",
  },
  leinHolderImage: {
    // minWidth:'100vw',
    // minHeight:'100vh',
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default JoinOurTeam;
